// ts-rest contract for the Book Health surface (C8). Firm admin only.
//
// GET /api/admin/book-health — the live convergence view: desk-user book sizes,
// unresolved grid manager strings, and stale canonical attributions. Backs the
// View → Administration Book Health card and the Desk empty-state hint.

import { initContract } from '@ts-rest/core';
import { bookHealthResponseSchema } from '../schemas/book-health';

const c = initContract();

export const bookHealthContract = c.router(
    {
        get: {
            method: 'GET',
            path: '/admin/book-health',
            responses: {
                200: bookHealthResponseSchema,
            },
            summary: 'Live desk-book health: empty books, unresolved managers, stale attributions',
        },
    },
    {
        pathPrefix: '/api',
        strictStatusCodes: false,
    },
);
